import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';

import { PanelWrapperComponent } from './panel-wrapper.component';
import { MatIconModule } from '@angular/material/icon';
import {
  AvatarModule,
  ButtonModule,
  MatTooltipAddonsDirective,
  UiModule,
} from '@lockton-apps/shared/ui/lui';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [PanelWrapperComponent],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      wrappers: [
        {
          name: 'panel',
          component: PanelWrapperComponent,
        },
      ],
    }),
    MatIconModule,
    AvatarModule,
    MaterialModule,
    ButtonModule,
    MatTooltipAddonsDirective,
    UiModule,
  ],
})
export class PanelWrapperModule {}
